import { render, staticRenderFns } from "./EditAccountSettingsDialog.vue?vue&type=template&id=6c95e706&scoped=true"
import script from "./EditAccountSettingsDialog.vue?vue&type=script&lang=js"
export * from "./EditAccountSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./EditAccountSettingsDialog.vue?vue&type=style&index=0&id=6c95e706&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c95e706",
  null
  
)

export default component.exports